import { useCallback, useEffect, useRef, useState } from 'react'
import { fetchPriceRanks } from '@/apis/aipass'
import type { PriceRank } from '@/models/room-rate/price-rank'

export const usePriceRanks = () => {
  const [ranks, setRanks] = useState<PriceRank[]>([])
  // 取得成功時のみ true。カレンダーの orphan 誤判定防止に使う
  const [ranksLoaded, setRanksLoaded] = useState(false)
  // 初回取得中のみ true。失敗時は false に戻し操作不能にしない
  const [ranksLoading, setRanksLoading] = useState(true)
  const cancelledRef = useRef(false)
  const initialLoadPendingRef = useRef(true)

  useEffect(() => {
    // StrictMode の remount 後も setRanks できるように戻す
    cancelledRef.current = false
    return () => {
      cancelledRef.current = true
    }
  }, [])

  const loadPriceRanks = useCallback(async () => {
    const isInitialLoad = initialLoadPendingRef.current
    if (isInitialLoad && !cancelledRef.current) {
      setRanksLoading(true)
    }
    try {
      const next = (await fetchPriceRanks()) || []
      if (!cancelledRef.current) {
        setRanks(next)
        setRanksLoaded(true)
        initialLoadPendingRef.current = false
      }
      return next
    } finally {
      if (isInitialLoad && !cancelledRef.current) {
        setRanksLoading(false)
      }
    }
  }, [])

  return { ranks, ranksLoaded, ranksLoading, loadPriceRanks }
}
